// Safari has MediaStreamTrackProcessor only inside workers, so mediabunny hands each camera/screen track to
// its own worker. It posts the track without listing it as transferable, and Safari only allows a
// MediaStreamTrack to be *transferred*: postMessage throws "The object can not be cloned" and the video is
// never recorded. Transfer it instead. The recorder always passes its own clone of the track, so moving
// that clone into the worker leaves the preview and the live call untouched.
const post = Worker.prototype.postMessage as (this: Worker, message: any, transfer?: any) => void;
Worker.prototype.postMessage = function (this: Worker, message: any, transfer?: any) {
  if (
    transfer == null &&
    message?.type === 'videoTrack' &&
    typeof MediaStreamTrack !== 'undefined' &&
    message.track instanceof MediaStreamTrack
  ) {
    return post.call(this, message, [message.track]);
  }
  return post.call(this, message, transfer);
} as typeof Worker.prototype.postMessage;
